import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMoneySend = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.312 19.05H6.189C4.223 19.05 3 17.663 3 15.7V8.3c0-1.963 1.223-3.35 3.188-3.35h11.624C19.772 4.95 21 6.337 21 8.3v2M18.809 14.39l2.136 2.136-2.136 2.136M20.944 16.525h-5.05M6.213 8.451h1.403"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.713 12.001a2.287 2.287 0 1 1 4.574 0 2.287 2.287 0 0 1-4.574 0"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMoneySend);
export default ForwardRef;
